// extracted by mini-css-extract-plugin
export default {"shareItem":"FileDetail_shareItem__zuQiE","iconContainer":"FileDetail_iconContainer__kz1Fi","icon":"FileDetail_icon__UcROh","itemContent":"FileDetail_itemContent__wC9js"};